export default "__VITE_ASSET__o8hW48mk__"